import React from "react";

const Qualification = () => (
  <section className="mk-section soft" id="qualification" data-testid="section-qualification">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2 className="mk-outline-title">Ne laissez plus un entretien client échouer si près du but</h2>
        </div>
      </div>
      <div className="mk-challenge mk-reveal">
        <article className="mk-problem">
          <span className="mk-tag">sans ASAP Hub</span>
          <h3>Difficile d'objectiver le niveau réel d'un candidat avant un entretien client.</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>Tests techniques non standardisés.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Les compétences réelles restent floues.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Le client découvre les faiblesses en entretien.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Risque de perdre la mission au dernier moment.</span></div>
          </div>
        </article>
        <article className="mk-solution">
          <span className="mk-tag">Avec ASAP Hub</span>
          <h3>ASAP Hub objectivise le niveau des candidats.</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>Tests automatisés et anti-triche.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Cartographie claire des compétences.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Préparation aux questions client.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Décision éclairée avant la présentation.</span></div>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default Qualification;
